import { connect } from 'react-redux'
import { defineMessages } from 'react-intl'
import { selectSellPocketAmount } from '../../../../../store/selectors/home/equity/sellPocket'
import SellPocketDetail from './SellPocketDetail'
import { SELLING_HOME_TOPIC_KEY } from '../../../../../constants/topicKeys'

export default {
  GemContainer: connect(state => ({
    qaTag: 'sellPocketGem',
    amount: selectSellPocketAmount(state),
  })),
  Detail: SellPocketDetail,
  ...defineMessages({
    question: {
      id: 'Homeowner.purchasePower.sellPocketQuestion',
      defaultMessage: 'Does it make sense to sell now?',
    },
    topic: {
      id: 'Homeowner.purchasePower.sellPocketTopic',
      defaultMessage: 'selling their home',
    },
  }),
  topicKey: SELLING_HOME_TOPIC_KEY,
}
